export default __webpack_public_path__ + "static/media/Roboto.c0eb0522.woff";